/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms.fk02

import com.ionspin.kotlin.bignum.decimal.BigDecimal
import io.kvision.core.*
import io.kvision.form.*
import io.kvision.form.check.CheckBox
import io.kvision.html.*
import io.kvision.state.bind
import io.kvision.utils.px
//import io.kvision.utils.pt
//import io.kvision.utils.perc
//import pl.finn.forms.utils.form.FormComponents

import io.kvision.form.check.RadioGroup
import io.kvision.form.select.Select
import io.kvision.form.select.selectOption
import io.kvision.form.text.*
import io.kvision.form.time.DateTime
import io.kvision.modal.Alert
import io.kvision.modal.Confirm
import pl.finn.forms.POLE_WYMAGANE
import pl.finn.forms.fk02.Model.formularzStore

import io.kvision.form.text.ImaskOptions
import io.kvision.panel.*
//import io.kvision.utils.auto
import pl.finn.forms.utils.model.Util
import kotlin.js.Date

class Fk02Panel : SimplePanel() {

//  private val formComponents = FormComponents()
  private val dynamicFieldsValidator = DynamicFieldsValidator()

  init {
    bind(formularzStore)
    { state ->
      main {
        margin = 15.px
        id = "peupcontent"
        state.bladZapisu?.let {
          div(it, className = "alert alert-danger") {
            role = "alert"
          }
        }
        when (state.widok) {
          FormularzWidok.EDYCJA, FormularzWidok.NOWY -> {
            if (state.form != null) {
              lateinit var numerSWIFT: Text
              lateinit var kodKraju: Select
              lateinit var walutaInnaNizPLN: Text
              lateinit var slownie: Text
              lateinit var czyObciazaPlanFinansowy: Div
              val formPanel = formPanel<Fk02Form>(
                type = FormType.HORIZONTAL, horizRatio = FormHorizontalRatio.RATIO_2, className = "mx-2 mx-md-5 mt-3",
                condensed = true
              ) {
                add(createButtonPanel(state, this@formPanel))

                h1(
                  "Polecenie Przelewu (FK-02)",
                  className = "h4 text-center"
                ) {
                  tabindex = -1
                }
//                tabPanel(TabPosition.TOP, className = "nav-pills") {//tabview
//                  id = "pills-tabs"//tabview
//                  tab("Dane podtawowe") {//tabview
//                    setAttribute("data-finn-toggle", "pill")//tabview
                add(
                  dynamicFieldsValidator.add( //pole nie jest dodawane i usuwane dynamicznie ale dostaje wartość z zewnatrz
                    Text(
                      value = state.form.numerRPP,
                      label = "Nr RPP"
                    ).apply {
                      onEvent {
                        change = {
                          state.form.numerRPP = self.value
                        }
                      }
                      styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                      flabel.addCssClass("required-label")
                    },
                    { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
                    POLE_WYMAGANE,
                    "numerRPP"
                  )
                )

                add(
                  dynamicFieldsValidator.add(
                    DateTime(
                      value = state.form.terminPlatnosci,
                      label = "Termin Płatności",
                      format = "YYYY-MM-DD"
                    ).apply {
                      onEvent {// miękki alert, wyświetla się po edycji pola, ale po sprawdzeniu dokumentu nie
                        change = {
                          state.form.terminPlatnosci = self.value
                          var actualDate = Date()
                          actualDate = Date(actualDate.getTime() - actualDate.getHours() * 60 * 60 * 1000 - actualDate.getMinutes() * 60 * 1000 - actualDate.getSeconds() * 1000 - actualDate.getMilliseconds())
                          if (self.value != null && (self.value as Date).getTime() < actualDate.getTime()) {
                            validatorError = "Czy jesteś pewien, że chcesz zapisać polecenie przelewu, ze wsteczną datą"
                          } else {
                            validatorError = null
                          }
                        }
                      }
                      styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                      flabel.addCssClass("required-label")
                    },
                    { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
                    POLE_WYMAGANE
                  )
                )

//                  }//tabview
//                  tab("Polecenie przelewu") {//tabview
                setAttribute("data-finn-toggle", "pill")
                add(
                  dynamicFieldsValidator.add(
                    TextArea(
                      value = state.form.naPodstawie,
                      label = "Na Podstawie",
                      rows = 4
                    ).apply {
                      onEvent {
                        change = {
                          state.form.naPodstawie = self.value
                        }
                      }
                      styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                      flabel.addCssClass("required-label")
                    },
                    { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
                    POLE_WYMAGANE
                  )
                )

                add(
                  dynamicFieldsValidator.add(
                    Text(
                      value = state.form.zRachunku,
                      label = "Z rachunku",
                      rich = true
                    ).apply {
                      onEvent {
                        change = {
                          state.form.zRachunku = self.value
                        }
                      }
                      enableTooltip(
                        TooltipOptions(
                          "CC-AAAA-AAAA-BBBB-BBBB-BBBB-BBBB<br>gdzie:<br>CC to suma kontrolna (2 cyfry) <br> AAAA-AAAA to numer rozliczeniowy jednostki organizacyjnej banku (8 cyfr) <br/> BBBB-BBBB-BBBB-BBBB to numer rachunku klienta w banku (16 cyfr).",
                          rich = true,
                          placement = Placement.BOTTOM
                        )
                      )
                      maskOptions = ImaskOptions(
                        pattern = PatternMask(
                          pattern = "00{ }0000{ }0000{ }0000{ }0000{ }0000{ }0000",
                          lazy = false,
                          eager = null,
                          placeholderChar = '_',
                          definitions = null,
                          blocks = null,
                        )
                      )
                      styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                      flabel.addCssClass("required-label")
                    },
                    { elem -> (validateAccountNumber(elem) == null && ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible))) },
                    { elem -> (validateAccountNumber(elem) ?: POLE_WYMAGANE) }
                  )
                )

                add(
                  dynamicFieldsValidator.add(
                    Text(
                      value = state.form.naRachunek,
                      label = "Na rachunek",
                      rich = true
                    ).apply {
                      onEvent {
                        change = {
                          state.form.naRachunek = self.value
                        }
                      }
                      enableTooltip(
                        TooltipOptions(
                          "CC-AAAA-AAAA-BBBB-BBBB-BBBB-BBBB<br>gdzie:<br>CC to suma kontrolna (2 cyfry) <br> AAAA-AAAA to numer rozliczeniowy jednostki organizacyjnej banku (8 cyfr) <br/> BBBB-BBBB-BBBB-BBBB to numer rachunku klienta w banku (16 cyfr).",
                          rich = true,
                          placement = Placement.BOTTOM
                        )
                      )
                      maskOptions = ImaskOptions(
                        pattern = PatternMask(
                          pattern = "00{ }0000{ }0000{ }0000{ }0000{ }0000{ }0000",
                          lazy = false,
                          eager = null,
                          placeholderChar = '_',
                          definitions = null,
                          blocks = null,
                        )
                      )
                      styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                      flabel.addCssClass("required-label")
                    },
                    { elem -> (validateAccountNumber(elem) == null && ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible))) },
                    { elem -> (validateAccountNumber(elem) ?: POLE_WYMAGANE) }
                  )
                )

                if (!state.form.posiadaSwiftIkodKraju) {
                  dynamicFieldsValidator.addNotValidationGroup("swiftIKodKraju")
                }
                add(
                  FieldsetPanel().apply {
                    add(
                      CheckBox(
                        value = state.form.posiadaSwiftIkodKraju,
                        label = "SWIFT i Kod Kraju",
                        rich = true
                      ).apply {
                        onEvent {
                          change = {
                            state.form.posiadaSwiftIkodKraju = self.value
                            if (self.value) {
                              numerSWIFT.show()
                              kodKraju.show()
                              dynamicFieldsValidator.removeNotValidationGroup("swiftIKodKraju")
                            } else {
                              numerSWIFT.hide()
                              kodKraju.hide()
                              dynamicFieldsValidator.addNotValidationGroup("swiftIKodKraju")
                            }
                          }
                        }
                        styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                        flabel.addCssClass("required-label")
                      }
                    )
                    add(
                      dynamicFieldsValidator.add(
                        Text(
                          value = state.form.numerSWIFT,
                          label = "SWIFT"
                        ).apply {
                          onEvent {
                            change = {
                              state.form.numerSWIFT = self.value
                            }
                          }
                          numerSWIFT = this
                          visible = state.form.posiadaSwiftIkodKraju
                          enableTooltip(TooltipOptions("Kod SWIFT zawiera 8 lub 11 znaków (litery oraz cyfry).<br> Wykorzystywany jest do identyfikacji instytucji finansowej, z którą dany podmiot chce wykonać transakcję międzynarodową.", rich = true, placement = Placement.BOTTOM))
                          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                          flabel.addCssClass("required-label")
                        },
                        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
                        POLE_WYMAGANE,
                        "swiftIKodKraju"
                      )
                    )
                    add(
                      dynamicFieldsValidator.add(
                        Select(
                          value = state.form.kodKraju,
                          label = "Kod Kraju"
                        ).apply {
                          onEvent {
                            change = {
                              state.form.kodKraju = self.value
                            }
                          }
                          kodKraju = this
                          visible = state.form.posiadaSwiftIkodKraju
                          for ((key, value) in Fk02Data.countryCodeMap) {
                            selectOption(value = key, label = value)
                            liveSearch = true
                          }
                          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                          flabel.addCssClass("required-label")
                        },
                        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
                        POLE_WYMAGANE,
                        "swiftIKodKraju"
                      )
                    )
                  }
                )

                add(
                  dynamicFieldsValidator.add( //pole nie jest dodawane i usuwane dynamicznie ale dostaje wartość z zewnatrz
                    Text(
                      value = state.form.nazwaOdbiorcy,
                      label = "Nazwa odbiorcy"
                    ).apply {
                      onEvent {
                        change = {
                          state.form.nazwaOdbiorcy = self.value
                        }
                      }
                      styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                      flabel.addCssClass("required-label")
                    },
                    { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
                    POLE_WYMAGANE,
                    "nazwaOdbiorcy"
                  )
                )
                add(
                  dynamicFieldsValidator.add( //pole nie jest dodawane i usuwane dynamicznie ale dostaje wartość z zewnatrz
                  TextArea(
                      value = state.form.adresOdbiorcy,
                      label = "Adres odbiorcy",
                      rows = 4
                    ).apply {
                      onEvent {
                        change = {
                          state.form.adresOdbiorcy = self.value
                        }
                      }
                      styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                      flabel.addCssClass("required-label")
                    },
                    { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
                    POLE_WYMAGANE,
                    "adresOdbiorcy"
                  )
                )
                add(
                  dynamicFieldsValidator.add(
                    Text(
                      value = state.form.kwotaPrzelewu,
                      label = "Kwota"
                    ).apply {
                      maskOptions = ImaskOptions(number =
                        NumberMask(
                          scale = 2,
                          signed = false,
                          thousandsSeparator = ' ',
                          padFractionalZeros = true,
                          normalizeZeros = true,
                          radix = ',',
                          mapToRadix = listOf<Char>('.')
                        )
                      )
                      onEvent {
                        change = {
                          state.form.kwotaPrzelewu = self.value
                          self.value?.let { it1 ->
                            slownie.setValue(NumberToWordAmountConverter.convertAmountFromNumberToWord(it1))
                            state.form.slownie = slownie.getValue()
//                            console.log("kwotaPrzelewu|"+state.form.kwotaPrzelewu?.toDouble())
//                            state.form.realizacjaBudzetu.forEach{
//                              console.log("kwota z budrzetu|"+it.kwota+"|"+it.kwota?.toDouble())
//                            }
//                                var sum = BigDecimal.parseString("0")
//                              state.form.realizacjaBudzetu.forEach {
////                                it.kwota?.toDouble() ?: "0".toDouble()
//                                  sum += (it.kwota?.let { kwota -> BigDecimal.parseString(kwota) } ?: run { BigDecimal.parseString("0") })
//                              }
//                            var sum = sumOfRealizacjaBudzetu(state.form.realizacjaBudzetu)
//                            console.log("suma|"+sum.toStringExpanded())
//                            console.log("kwota prz|"+ BigDecimal.parseString(state.form.kwotaPrzelewu ?: "0"))
//                            console.log("compare: "+ (sum == BigDecimal.parseString(state.form.kwotaPrzelewu ?: "0")).toString())
//                            state.form.realizacjaBudzetu.forEach { rb ->
//                              console.log("rb: "+rb.dzial+"kwota: "+rb.kwota)
//                            }
                          }
                        }
                        blur = {
                          self.maskOptions = ImaskOptions(number =
                          NumberMask(
                            scale = 2,
                            signed = false,
                            thousandsSeparator = ' ',
                            padFractionalZeros = true,
                            normalizeZeros = true,
                            radix = ',',
                            mapToRadix = listOf<Char>('.')
                          )
                          )
                        }
                        focus = {
                          self.maskOptions = ImaskOptions(number =
                          NumberMask(
                            scale = 2,
                            signed = false,
                            thousandsSeparator = ' ',
                            padFractionalZeros = false,
                            normalizeZeros = false,
                            radix = ',',
                            mapToRadix = listOf<Char>('.')
                          )
                          )
                        }
                      }
                      styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                      flabel.addCssClass("required-label")
                    },
                    { elem -> ((
                      (!elem.isNullOrEmpty() && !elem.isBlank()) &&
                        (
                          (state.form.czyObciazaPlanFinansowy == "0") ||
                            (state.form.realizacjaBudzetu.size > 0 &&
                              ((BigDecimal.parseString(state.form.kwotaPrzelewu ?: "0")) == sumOfRealizacjaBudzetu(state.form.realizacjaBudzetu))
                            )
                        )
                    )) },
                    { elem -> (if( !elem.isNullOrEmpty() && !elem.isBlank() ) "Suma obciążeń planu finansowego, wynosi " + Util.parseAmount(sumOfRealizacjaBudzetu(state.form.realizacjaBudzetu).toStringExpanded()) + "." else POLE_WYMAGANE) }
                  )
                )

                if (state.form.czyWalutaInnaNizPLN == "0") {
                  dynamicFieldsValidator.addNotValidationGroup("walutaInnaNizPLN")
                }

                add(
                  FieldsetPanel().apply {
                    add(
                      dynamicFieldsValidator.add(
                        RadioGroup(
                          options = listOf("0" to "PLN", "1" to "Inna"),
                          value = state.form.czyWalutaInnaNizPLN,
                          label = "Waluta",
                          inline = true
                        ).apply {
                          onEvent {
                            change = {
                              state.form.czyWalutaInnaNizPLN = self.value
                              if (self.value == "0") {
                                walutaInnaNizPLN.hide()
                                dynamicFieldsValidator.addNotValidationGroup("walutaInnaNizPLN")
                              } else {
                                walutaInnaNizPLN.show()
                                dynamicFieldsValidator.removeNotValidationGroup("walutaInnaNizPLN")
                              }
                            }
                          }
                          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                          flabel.addCssClass("required-label")
                        },
                        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
                        POLE_WYMAGANE
                      )
                    )

                    add(
                      dynamicFieldsValidator.add(
                        Text(
                          value = state.form.walutaInnaNizPLN,
                          label = "Waluta inna niż PLN"
                        ).apply {
                          onEvent {
                            change = {
                              state.form.walutaInnaNizPLN = self.value
                            }
                          }
                          walutaInnaNizPLN = this
                          visible = state.form.czyWalutaInnaNizPLN == "1"
                          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                          flabel.addCssClass("required-label")
                        },
                        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
                        POLE_WYMAGANE,
                        "walutaInnaNizPLN"
                      )
                    )
                  }
                )
                add(
                  dynamicFieldsValidator.add(
                    Text(
                      value = state.form.slownie,
                      label = "Słownie"
                    ).apply {
                      onEvent {
                        change = {
                          state.form.slownie = self.value
                        }
                      }
                      slownie = this
                      styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                      flabel.addCssClass("required-label")
                    },
                    { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
                    POLE_WYMAGANE
                  )
                )
                add(
                  dynamicFieldsValidator.add(
                    TextArea(
                      value = state.form.tytulem,
                      label = "Tytułem",
                      rows = 4
                    ).apply {
                      onEvent {
                        change = {
                          state.form.tytulem = self.value
                        }
                      }
                      styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                      flabel.addCssClass("required-label")
                    },
                    { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
                    POLE_WYMAGANE
                  )
                )
//                  }//tabview
//                  tab("Obciążenie planu finansowego") {//tabview
//                    setAttribute("data-finn-toggle", "pill")//tabview

                czyObciazaPlanFinansowy = createBudgetImplementations(state, this)
                if (state.form.czyObciazaPlanFinansowy == "0") {
                  czyObciazaPlanFinansowy.hide()
                  dynamicFieldsValidator.addNotValidationGroup("czyObciazaPlanFinansowy")
                }
                add(
                  FieldsetPanel().apply {
                    add(
                      dynamicFieldsValidator.add(
                        RadioGroup(
                          options = listOf("0" to "NIE", "1" to "TAK"),
                          value = state.form.czyObciazaPlanFinansowy,
                          label = "Czy obciąża plan finansowy?",
                          inline = true
                        ).apply {
                          onEvent {
                            change = {
                              state.form.czyObciazaPlanFinansowy = self.value
                              if (self.value == "0") {
                                czyObciazaPlanFinansowy.hide()
                                dynamicFieldsValidator.addNotValidationGroup("czyObciazaPlanFinansowy")
                              } else {
                                czyObciazaPlanFinansowy.show()
                                dynamicFieldsValidator.removeNotValidationGroup("czyObciazaPlanFinansowy")
                                if (state.form.realizacjaBudzetu.isEmpty()) {
                                  state.form.realizacjaBudzetu.add(RealizacjaBudzetu(kwota = state.form.kwotaPrzelewu))
                                  refreshBudgetImplementationElements(state, czyObciazaPlanFinansowy)
                                }
                                if (state.form.realizacjaBudzetu.size == 1) {
                                  state.form.realizacjaBudzetu.get(0).kwota = state.form.kwotaPrzelewu
                                  refreshBudgetImplementationElements(state, czyObciazaPlanFinansowy)
                                }
                              }
                            }
                          }
                          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                          flabel.addCssClass("required-label")
                        },
                        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
                        POLE_WYMAGANE
                      )
                    )
                    add(czyObciazaPlanFinansowy)
                  }
                )

//                  }//tabview
//                  tab("Uwagi") {//tabview
//                    setAttribute("data-finn-toggle", "pill")//tabview
                add(createComments(state, this))

//                  }//tabview
//                }//tabview
//                add(formComponents.createNavigationButtons())//tabview
              }
            }
          }
          else -> {}
        }
      }
    }
  }

  private fun createComments(state: Formularz, formPanel: FormPanel<Fk02Form>): FieldsetPanel {
    val div = FieldsetPanel()

    if (state.form?.uwagi != null) {
      if (state.form.uwagi.isEmpty()) {
        state.form.uwagi.add(Uwagi(""))
      }
      div.apply {
        state.form.uwagi.forEach { uwagi ->
          add(
            dynamicFieldsValidator.add(
              Text(value = uwagi.uwagi, label = "Uwagi").apply {
                onEvent {
                  change = {
                    uwagi.uwagi = self.value
                  }
                }
                styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                flabel.addCssClass("required-label")
              },
              { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
              POLE_WYMAGANE
            )
          )
        }
      }
    }
    div.addAll(createCommentsButtons(state, div).getChildren())
    return div
  }

  private fun createCommentsButtons(state: Formularz, div: FieldsetPanel): Div {
    return Div(className = "p-2 d-flow-root") {
      button(
        "Usuń",
        "far fa-minus-square",
        ButtonStyle.OUTLINEPRIMARY, className = "btn-sm"
      ).apply {
        visible = state.form?.uwagi != null && state.form.uwagi.size > 1
      }.onClick {
        if (state.form?.uwagi != null && state.form.uwagi.size > 1) {
          state.form.uwagi.removeLast()
          dynamicFieldsValidator.removeAll(div.getChildren() as List<FormControl>)
          div.removeAll()
          div.apply {
            state.form.uwagi.forEach { uwagi ->
              add(
                dynamicFieldsValidator.add(
                  Text(value = uwagi.uwagi, label = "Uwagi").apply {
                    onEvent {
                      change = {
                        uwagi.uwagi = self.value
                      }
                    }
                    styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                    flabel.addCssClass("required-label")
                  },
                  { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
                  POLE_WYMAGANE
                )
              )
            }
          }
          div.addAll(createCommentsButtons(state, div).getChildren())
        }
      }
      button(
        "Dodaj",
        "far fa-plus-square",
        ButtonStyle.OUTLINEPRIMARY, className = "btn-sm float-right"
      ).onClick {
        if (state.form?.uwagi != null) {
          state.form.uwagi.add(Uwagi(""))
          dynamicFieldsValidator.removeAll(div.getChildren() as List<FormControl>)
          div.removeAll()
          div.apply {
            state.form.uwagi.forEach { uwagi ->
              add(
                dynamicFieldsValidator.add(
                  Text(value = uwagi.uwagi, label = "Uwagi").apply {
                    onEvent {
                      change = {
                        uwagi.uwagi = self.value
                      }
                    }
                    styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                    flabel.addCssClass("required-label")
                  },
                  { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
                  POLE_WYMAGANE
                )
              )
            }
          }
          div.addAll(createCommentsButtons(state, div).getChildren())
        }
      }
    }
  }

  fun createBudgetImplementations(state: Formularz, formPanel: FormPanel<Fk02Form>): Div {

    return Div().apply {
      visible = state.form?.czyObciazaPlanFinansowy == "1"
      if (state.form?.realizacjaBudzetu != null) {
        if (state.form.realizacjaBudzetu.isEmpty()) {
          state.form.realizacjaBudzetu.add(RealizacjaBudzetu())
        }
        state.form.realizacjaBudzetu.forEach {
          add(
            createBudgetImplementationElement(it)
          )
        }
      }
      addAll(createbudgetImplementationsButtons(state, this).getChildren())
    }

  }

  private fun createbudgetImplementationsButtons(state: Formularz, div: Div): Div {
    return (
      Div(className = "p-2 d-flow-root") {
        button(
          "Usuń",
          "far fa-minus-square",
          ButtonStyle.OUTLINEPRIMARY, className = "btn-sm"
        ).apply {
          visible = state.form?.realizacjaBudzetu != null && state.form.realizacjaBudzetu.size > 1
        }.onClick {

          if (state.form?.realizacjaBudzetu != null && state.form.realizacjaBudzetu.size > 1) {
            state.form.realizacjaBudzetu.removeLast()
            refreshBudgetImplementationElements(state, div)
          }

        }
        button(
          "Dodaj",
          "far fa-plus-square",
          ButtonStyle.OUTLINEPRIMARY, className = "btn-sm float-right"
        ).onClick {

          if (state.form?.realizacjaBudzetu != null) {
            state.form.realizacjaBudzetu.add(RealizacjaBudzetu())
            refreshBudgetImplementationElements(state, div)
          }

        }
      }
    )
  }

  private fun refreshBudgetImplementationElements(state: Formularz, div: Div) {
    if (state.form?.realizacjaBudzetu != null) {
      dynamicFieldsValidator.removeAll(div.getChildren() as List<FormControl>)
      div.removeAll()
      div.apply {
        state.form.realizacjaBudzetu.forEach {
          add(
            createBudgetImplementationElement(it)
          )
        }
      }
      div.addAll(createbudgetImplementationsButtons(state, div).getChildren())
    }
  }

  private fun createBudgetImplementationElement(realizacjaBudzetu: RealizacjaBudzetu): FieldsetPanel {
    return FieldsetPanel().apply {
      add(
        dynamicFieldsValidator.add(
          Text(
            value = realizacjaBudzetu.nrCruUmowyLubNrWnioskuZd,
            label = "Nr CRU umowy lub Nr wniosku ZD"
          ).apply {
            onEvent {
              change = {
                realizacjaBudzetu.nrCruUmowyLubNrWnioskuZd = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
            flabel.addCssClass("required-label")
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
          POLE_WYMAGANE,
          "czyObciazaPlanFinansowy"
        )
      )
      add(
        dynamicFieldsValidator.add(
          Text(
            value = realizacjaBudzetu.kwota,
            label = "Kwota"
          ).apply {
            onEvent {
              change = {
                realizacjaBudzetu.kwota = self.value
              }
              blur = {
                self.maskOptions = ImaskOptions(number =
                NumberMask(
                  scale = 2,
                  signed = false,
                  thousandsSeparator = ' ',
                  padFractionalZeros = true,
                  normalizeZeros = true,
                  radix = ',',
                  mapToRadix = listOf<Char>('.')
                )
                )
              }
              focus = {
                self.maskOptions = ImaskOptions(number =
                NumberMask(
                  scale = 2,
                  signed = false,
                  thousandsSeparator = ' ',
                  padFractionalZeros = false,
                  normalizeZeros = false,
                  radix = ',',
                  mapToRadix = listOf<Char>('.')
                )
                )
              }
            }
            //        enableTooltip(TooltipOptions(null, rich = true, placement = Placement.BOTTOM))
            maskOptions = ImaskOptions(
              number = NumberMask(
                scale = 2,
                signed = false,
                thousandsSeparator = ' ',
                padFractionalZeros = true,
                normalizeZeros = true,
                radix = ',',
                mapToRadix = listOf<Char>('.')
              )
            )
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
            flabel.addCssClass("required-label")
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
          POLE_WYMAGANE,
          "czyObciazaPlanFinansowy"
        )
      )
      add(
        dynamicFieldsValidator.add(
          Text(
            value = realizacjaBudzetu.dzial,
            label = "Dział"
          ).apply {
            onEvent {
              change = {
                realizacjaBudzetu.dzial = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
            flabel.addCssClass("required-label")
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
          POLE_WYMAGANE,
          "czyObciazaPlanFinansowy"
        )
      )
      add(
        dynamicFieldsValidator.add(
          Text(
            value = realizacjaBudzetu.rozdzial,
            label = "Rozdział"
          ).apply {
            onEvent {
              change = {
                realizacjaBudzetu.rozdzial = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
            flabel.addCssClass("required-label")
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
          POLE_WYMAGANE,
          "czyObciazaPlanFinansowy"
        )
      )
      add(
        dynamicFieldsValidator.add(
          Text(
            value = realizacjaBudzetu.paragraf,
            label = "Paragraf"
          ).apply {
            onEvent {
              change = {
                realizacjaBudzetu.paragraf = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
            flabel.addCssClass("required-label")
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
          POLE_WYMAGANE,
          "czyObciazaPlanFinansowy"
        )
      )
      add(
        dynamicFieldsValidator.add(
          Text(
            value = realizacjaBudzetu.zadanieBudzetowe,
            label = "Zadanie budżetowe"
          ).apply {
            onEvent {
              change = {
                realizacjaBudzetu.zadanieBudzetowe = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
            flabel.addCssClass("required-label")
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
          POLE_WYMAGANE,
          "czyObciazaPlanFinansowy"
        )
      )
      add(
        dynamicFieldsValidator.add(
          Text(
            value = realizacjaBudzetu.zrodloFinansowania,
            label = "Źródło finansowania"
          ).apply {
            onEvent {
              change = {
                realizacjaBudzetu.zrodloFinansowania = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
            flabel.addCssClass("required-label")
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
          POLE_WYMAGANE,
          "czyObciazaPlanFinansowy"
        )
      )
      add(
        dynamicFieldsValidator.add(
          Select(
            value = realizacjaBudzetu.obiektBudzetowy,
            label = "Obiekt budżetowy"
          ).apply {
            onEvent {
              change = {
                realizacjaBudzetu.obiektBudzetowy = self.value
              }
            }
            for (enum in Fk02Data.listOfBudgetFacility) {
              selectOption(value = enum,label = enum)
              liveSearch = false
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
            flabel.addCssClass("required-label")
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
          POLE_WYMAGANE,
          "czyObciazaPlanFinansowy"
        )
      )
    }
  }

  fun createButtonPanel(state: Formularz, reference: FormPanel<Fk02Form>): Div {
    return (
      Div(className = "form-group my-3") {
        div(className = "row") {
          div(className = "col-lg-6") {
            div(className = "row") {
              div(className = "col-sm-6 py-2") {
                button(
                  "Zapisz dokument",
                  "far fa-save fa-3x d-block",
                  ButtonStyle.SUCCESS, className = "w-100"
                ).onClick {
                  val referenceData = state.form//getReferenceData(reference, state)
                  val validateResult =
                    if (!(/*reference.validate() &&*/ dynamicFieldsValidator.validate())) "Dokument zawiera niepoprawne dane." else null
                  referenceData?.let { it1 -> Model.zapisz(it1, validateResult) }
                }
              }
              div(className = "col-sm-6 py-2") {
                button("Sprawdź dokument", "fas fa-tasks fa-3x d-block", className = "w-100").onClick {
//                  val isValidatedStatic = reference.validate()
                  val isValidatedDynamic = dynamicFieldsValidator.validate()
                  if (/*isValidatedStatic &&*/ isValidatedDynamic) {
                    Alert.show(
                      "Sprawdzenie dokumentu",
                      "Dokument jest poprawny.<br/>Wszystkie pola wypełnione są prawidłowo.",
                      rich = true
                    )
                  } else {
                    Alert.show(
                      "Sprawdzenie dokumentu",
                      "Dokument zawiera niepoprawne dane.<br/>Należy poprawić pola oznaczone na czerwono.",
                      rich = true
                    )
                  }
                  Model.sprawdz()
                }
              }
            }
          }
          div(className = "col-lg-6") {
            div(className = "row") {
              div(className = "col-sm-6 py-2") {
                button("Podgląd dokumentu", "fas fa-eye fa-3x d-block", className = "w-100").onClick {
                  val referenceData = state.form//getReferenceData(reference, state)
                  referenceData?.let { it1 -> Model.podglad(it1, this) }
                }
              }
              div(className = "col-sm-6 py-2") {
                button(
                  "Anuluj",
                  "fas fa-times fa-3x d-block",
                  ButtonStyle.SECONDARY, className = "w-100"
                ).onClick {
                  Confirm.show(
                    "Potwierdzenie",
                    "Czy anulować edycję formularza i powrócić do poprzedniej strony?",
                    yesTitle = "Tak",
                    noTitle = "Nie"
                  ) {
                    Model.anuluj()
                  }
                }
              }
            }
          }
        }
      }
    )
  }

//  private fun getReferenceData(reference: FormPanel<Fk02Form>, state: Formularz): Fk02Form? {
//    val referenceData = reference.getData()
//    if (referenceData != null) {
//      if (state.form?.numerRPP != null) {
//        referenceData.numerRPP = state.form.numerRPP
//      }
//      if (state.form?.nazwaOdbiorcy != null) {
//        referenceData.nazwaOdbiorcy = state.form.nazwaOdbiorcy
//      }
//      if (state.form?.adresOdbiorcy != null) {
//        referenceData.adresOdbiorcy = state.form.adresOdbiorcy
//      }
//      if (state.form?.realizacjaBudzetu != null && referenceData.czyObciazaPlanFinansowy == "1") {
//        referenceData.realizacjaBudzetu.clear()
//        referenceData.realizacjaBudzetu.addAll(state.form.realizacjaBudzetu)
//      }
//      if (state.form?.uwagi != null) {
//        referenceData.uwagi.clear()
//        referenceData.uwagi.addAll(state.form.uwagi)
//      }
//    }
//    return referenceData
//  }

  private fun sumOfRealizacjaBudzetu(realizacjaBudzetu: ArrayList<RealizacjaBudzetu>): BigDecimal {
    var sum = BigDecimal.parseString("0")
    realizacjaBudzetu.forEach {
      sum += (it.kwota?.let { kwota -> BigDecimal.parseString(kwota) } ?: run { BigDecimal.parseString("0") })
    }
    return sum
  }

  fun validateAccountNumber(accountNumber: String?): String? {
    val countryCodeCoded = "2521" // PL (P - 25, L - 21)
    if (accountNumber == null) {
      return "Nie wpisano numeru konta"
    }

    //1. wywalić biale znaki
    val accountNumberWithoutSpaces = accountNumber
      .replace(" ", "")
      .replace("_", "")
      .replace("-", "")

    //2. if(dł!=26) zla dlugosc
    if (accountNumberWithoutSpaces.length != 26) {
      return "Zła długość"
    }

    //3. |skladamy nr konta bez 2 cyfr od lewej|kod kraju z numerku(2521)|2 cyfry kontrolne z nr konta
    val temp = (accountNumberWithoutSpaces.substring(2) + countryCodeCoded + accountNumberWithoutSpaces.substring(0, 2))
    //4. mod 97 == 1 //z powodu, że liczba nie mieści się w zakresie obliczenie modulo 97 odbywa się etapowo na mniejszych fragmentach
    val temp2 = temp.substring(0, 10).toLong() % 97L
    val temp3 = (temp2.toString() + temp.substring(10, 20)).toLong() % 97L
    val temp4 = (temp3.toString() + temp.substring(20)).toLong() % 97L
    if (temp4 != 1L) {
      return "Błąd w numerze rachunku"
    }

    return null
  }

}
